import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['payments'],
  setupIntent: (): QueryKey => [...queryKeys.all, 'setupIntent'],
};
